import * as React from 'react';
import { UIHeading3, useDeviceType } from '@cian/ui-kit';
import cx from 'clsx';
import { ContactMainInfo } from '../../internal/components/ContactMainInfo';
import { ContactFeaturesContext } from '../partials/ContactFeatures/internal';
import * as styles from './styles.module.css';
import { ContactActionsContext } from '../partials/ContactActions/internal';
import { ContactAvatarContext } from '../partials/ContactAvatar/internal';

/**
 * Компонент Контакта для использования на карточках
 *
 * Адаптивный
 * Использует useDeviceType из ui-kit
 */
export function ContactCard(_ref) {
  var title = _ref.title,
      name = _ref.name,
      href = _ref.href,
      target = _ref.target,
      onNameClick = _ref.onNameClick,
      nameIcons = _ref.nameIcons,
      avatar = _ref.avatar,
      labels = _ref.labels,
      features = _ref.features,
      subcontact = _ref.subcontact,
      actions = _ref.actions,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var deviceType = useDeviceType();
  var isPremiumTheme = theme === 'premium';
  var isWhiteBackground = isPremiumTheme || deviceType === 'desktop';
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles['card'], deviceType !== 'desktop' && styles['mobile'], styles["theme_" + theme])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['section']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['avatar']
  }, /*#__PURE__*/React.createElement(ContactAvatarContext.Provider, {
    value: {
      size: 72,
      highlight: isPremiumTheme ? 'white_100' : null
    }
  }, avatar)), /*#__PURE__*/React.createElement("div", {
    className: styles['main-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-info']
  }, /*#__PURE__*/React.createElement(ContactMainInfo, {
    NameHeadingComponent: UIHeading3,
    title: title,
    name: name,
    href: href,
    target: target,
    onNameClick: onNameClick,
    nameIcons: nameIcons,
    vertical: isPremiumTheme
  })), labels)), features && /*#__PURE__*/React.createElement(ContactFeaturesContext.Provider, {
    value: {
      background: isWhiteBackground ? 'gray6_100' : 'gray10_100'
    }
  }, features)), subcontact && /*#__PURE__*/React.createElement("div", {
    className: styles['section']
  }, subcontact), actions && /*#__PURE__*/React.createElement("div", {
    className: styles['actions']
  }, /*#__PURE__*/React.createElement(ContactActionsContext.Provider, {
    value: {
      mobileButtonBackground: isPremiumTheme ? 'white_100' : 'gray6_100'
    }
  }, actions)));
}